import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth-service.service';
import {ConnectService, SsoService} from 'sigale-angular';
import {TranslateService} from '@ngx-translate/core';
import {NavigationEnd, Router} from '@angular/router';
import {UtilisateurSigalett} from '../../models/utilisateur-sigalett.model';
import {MenuItem} from 'primeng/api';

@Component({
	selector: 'app-menu',
	templateUrl: './menu.component.html',
	styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit {
	items: MenuItem[] | undefined;
	utilisateurItems: MenuItem[] | undefined;
	utilisateur: UtilisateurSigalett;
	selectedLabel: string = '';

	constructor(
		private authService: AuthService,
		private translateService: TranslateService,
		private connectService: ConnectService,
		private router: Router,
		private ssoService: SsoService) {
	}

	ngOnInit() {
		this.utilisateur = this.authService.getUtilisateurConnecte();
		this.translateService.get('MENU').subscribe(traductions => {
			// menu principal
			this.items = [
				{
					label: traductions.ACCUEIL,
					icon: 'pi pi-calendar',
					route: 'accueil',
					droit: 'TELETRAVAIL_ABSENCE_RESERVATION',
					command: () => {
						this.selectedLabel = traductions.ACCUEIL;
					}
				},
				{
					label: traductions.PLANNING,
					icon: 'pi pi-th-large',
					route: 'planning',
					droit: 'VOIR_PLANNING',
					command: () => {
						this.selectedLabel = traductions.PLANNING;
					}
				},
				{
					label: traductions.GESTION_EQUIPE,
					icon: 'pi pi-users',
					route: 'gestion-equipe',
					droit: 'GESTION_EQUIPE',
					command: () => {
						this.selectedLabel = traductions.GESTION_EQUIPE;
					}
				},
				{
					label: traductions.VALIDATION,
					icon: 'pi pi-check-circle',
					route: 'validation-teletravail',
					droit: 'VALIDATION_TT',
					command: () => {
						this.selectedLabel = traductions.VALIDATION;
					}
				},
				{
					label: traductions.RESERVATION_NAVETTE,
					icon: 'fa fa-route',
					route: 'reservation-navette',
					droit: 'RESERVATION_NAVETTE',
					command: () => {
						this.selectedLabel = traductions.RESERVATION_NAVETTE;
					}
				},
				{
					label: traductions.GESTION_NAVETTE,
					icon: 'fa fa-bus',
					route: 'gestion-navette',
					droit: 'GESTION_NAVETTE',
					command: () => {
						this.selectedLabel = traductions.GESTION_NAVETTE;
					}
				},
			];

			// Sous-menu visible lors du click sur le bouton utilisateur
			this.utilisateurItems = [
				{
					label: `Connecté en tant que ${this.utilisateur.firstName} ${this.utilisateur.lastName}`,
					items: [
						{
							label: traductions.PREFERENCES,
							icon: 'pi pi-cog',
							route: 'preferences',
							command: () => {
								this.router.navigate(['/preferences']);
								this.selectedLabel = traductions.PREFERENCES;
							}
						},
						{
							label: traductions.SE_DECONNECTER,
							icon: 'pi pi-sign-out',
							command: () => {
								this.logout();
							}
						}
					]
				}
			];

			// Mettre à jour l'onglet actif à chaque navigation
			this.router.events.subscribe(event => {
				if (event instanceof NavigationEnd) {
					const url = event.urlAfterRedirects;
					if (url === '/' || url.includes('accueil')) {
						this.selectedLabel = traductions.ACCUEIL;
					}
					else if (url.includes('planning')) {
						this.selectedLabel = traductions.PLANNING;
					}
					else if (url.includes('gestion-equipe')) {
						this.selectedLabel = traductions.GESTION_EQUIPE;
					}
					else if (url.includes('gestion-navette')) {
						this.selectedLabel = traductions.GESTION_NAVETTE;
					}
					else if (url.includes('reservation-navette')) {
						this.selectedLabel = traductions.RESERVATION_NAVETTE;
					}
					else if (url.includes('validation')) {
						this.selectedLabel = traductions.VALIDATION;
					}
					else if (url.includes('preferences')) {
						this.selectedLabel = traductions.PREFERENCES;
					}
				}
			});
		});
	}

	/**
	 * Permet de déconnecter l'utilisateur.
	 */
	logout(): void {
		this.connectService.logout();
		this.ssoService.deconnexion(true);
	}

	isActive(item: any): boolean {
		return item.route && this.router.isActive(item.route, { paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' });
	}

	/**
	 * Vérifie si l'utilisateur connecté peut accéder à l'item du menu.
	 * @param droitItem le droit nécessaire de l'item du menu.
	 */
	public verifierDroits(droitItem: string): boolean {
		return this.authService.droitsUtilisateurConnecte().includes(droitItem);
	}
}
